/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import FooterStepButton from "../components/FooterStepButton";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import BookingStepList from "../components/booking/steps/BookingStepList";
import ProvidersList from "../components/booking/provider/ProvidersList";
import { useBooking } from "../hooks/useBooking";

const Providers = () => {
  const { selectedProvider } = useBooking();

  return (
    <Container>
      <NavigationHeader location back="step" />
      <BookingStepList title="Select provider">
        <ProvidersList />
      </BookingStepList>
      {selectedProvider && <FooterStepButton />}
    </Container>
  );
};

export default Providers;
